import { RouterProvider, createBrowserRouter } from "react-router-dom";
import { useEffect, useState } from "react";
import { AllRoutes } from "../Utils/Constants";
import withRole from "../Hooks/withRole";
import { LocalRouterProps } from "../Utils/Types";
import { isFreeSubscription } from "../Utils/Utils";
import { localUrlEnum, pathParams } from "../Utils/UrlEnum";

const LocalRouter = (props: LocalRouterProps) => {
  const [router, setRouter] = useState<any>();

  /**
   *
   */
  useEffect(() => {
    if (!props.routes) return;
    setRouter(filterAndVerifyRoutes(AllRoutes, props.routes));
  }, [props]);

  /**
   *
   * @param routes
   * @returns
   */

  /**
   *
   * @param routerPaths
   * @param routes
   * @returns
   */
  const filterAndVerifyRoutes = (routerPaths: any, routes: any) => {
    const isFree = isFreeSubscription();
    const blockedForFreeRoutes = [
      localUrlEnum.statistics,
      localUrlEnum.liveLegislation,
      `${localUrlEnum.liveLegislation}${pathParams.roomName}`,
    ];

    return routerPaths.reduce((filteredPaths: any, pathObj: any) => {
      const isValidPath = routes.includes(pathObj.path);
      const isBlockedForFree = isFree && blockedForFreeRoutes.includes(pathObj.path);

      if (isValidPath && !isBlockedForFree) {
        if (pathObj.children && pathObj.children.length > 0) {
          const validChildren = filterAndVerifyRoutes(pathObj.children, routes);
          if (validChildren.length > 0) {
            filteredPaths.push({ ...pathObj, children: validChildren });
          }
        } else {
          filteredPaths.push(pathObj);
        }
      }

      return filteredPaths;
    }, []);
  };

  return (
    <RouterProvider
      router={createBrowserRouter(router || AllRoutes)}
    ></RouterProvider>
  );
};

export default withRole(LocalRouter);
